export default __webpack_public_path__ + "static/media/sam-and-karen-kissing-spain.02970967.png";